import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/form.css";
import axios from "axios";

function Form() {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    address: "",
    date: "",
    pincode: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.mobile ||
      !formData.address ||
      !formData.date ||
      !formData.pincode
    ) {
      alert("Please fill all fields before submitting.");
      return;
    }

    try {
      await axios.post("http://localhost:5000/add-users", [formData]);

      alert("Data saved successfully!");

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        address: "",
        date: "",
        pincode: "",
      });

      // optional redirect
      // navigate("/table");

    } catch (error) {
      console.error("Error saving data:", error);

      if (error.response && error.response.data && error.response.data.error) {
        alert(error.response.data.error);  // 🔥 Backend ka real error (duplicate etc.)
      } else if (error.response) {
        alert("Server error. Please try again.");
      } else if (error.request) {
        alert("Network error. Backend server not responding.");
      } else {
        alert("Something went wrong.");
      }
    }
  };

  return (
    <section className="cursed-form-section">
      <h2 className="form-title">Welcome</h2>

      <form className="cursed-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <input type="text" name="firstName" placeholder="First Name"
            value={formData.firstName} onChange={handleChange} />

          <input type="text" name="lastName" placeholder="Last Name"
            value={formData.lastName} onChange={handleChange} />
        </div>

        <div className="form-row">
          <input type="email" name="email" placeholder="Email Address"
            value={formData.email} onChange={handleChange} />

          <input type="tel" name="mobile" placeholder="Mobile Number"
            value={formData.mobile} onChange={handleChange} />
        </div>

        <div className="form-row">
          <input type="text" name="address" placeholder="Address"
            value={formData.address} onChange={handleChange} />
        </div>

        <div className="form-row">
          <input type="date" name="date"
            value={formData.date} onChange={handleChange} />

          <input type="text" name="pincode" placeholder="Pincode"
            value={formData.pincode} onChange={handleChange} />
        </div>

        <button type="submit" className="submit-btn">
          Submit
        </button>

        <p
          className="view-data-line"
          onClick={() => navigate("/table")}
        >
          Enter the Archive →
        </p>
      </form>
    </section>
  );
}

export default Form;